"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getApplicationDisclosures = exports.esignDisclosure = exports.downloadDocument = exports.GET_APPLICATION_DISCLOSURES = exports.ESIGN_DISCLOSURE = exports.DOWNLOAD_DOCUMENT = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _ajax = require("./ajax");

var _httpActions = require("./http-actions");

var _env = require("../env");

var GET_APPLICATION_DISCLOSURES = 'GET_APPLICATION_DISCLOSURES';
exports.GET_APPLICATION_DISCLOSURES = GET_APPLICATION_DISCLOSURES;
var DOWNLOAD_DOCUMENT = 'DISCLOSURE_DOWNLOAD_DOCUMENT';
exports.DOWNLOAD_DOCUMENT = DOWNLOAD_DOCUMENT;
var ESIGN_DISCLOSURE = 'ESIGN_DISCLOSURE';
exports.ESIGN_DISCLOSURE = ESIGN_DISCLOSURE;
var CONTEXT = _env.isMerchant ? '/app-merloc/secure/api/v1/applications' : '/service-application/api/v1/applications';
var ELECTRONIC_DOCUMENT_CONTEXT = '/electronic-documents/api/v1';

var getApplicationDisclosures = function getApplicationDisclosures(applicationUuid, disclosurelistUuid) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _ajax.ajaxGet)(GET_APPLICATION_DISCLOSURES, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/").concat(applicationUuid, "/disclosure/").concat(disclosurelistUuid)));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getApplicationDisclosures = getApplicationDisclosures;

var downloadDocument = function downloadDocument(applicationUuid, disclosurelistUuid, documentUuid) {
  var contentDisposition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'inline';
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", (0, _ajax.ajaxGet)(DOWNLOAD_DOCUMENT, dispatch, // eslint-disable-next-line
              "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/").concat(applicationUuid, "/disclosure/").concat(disclosurelistUuid, "/document/").concat(documentUuid, "/download?contentDisposition=").concat(contentDisposition), {
                responseType: 'arraybuffer'
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
}; // { applicationUuid, documentUuid, latitude, longitude, consentToEsign }


exports.downloadDocument = downloadDocument;

var esignDisclosure = function esignDisclosure(data) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", (0, _ajax.ajaxPost)(ESIGN_DISCLOSURE, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(ELECTRONIC_DOCUMENT_CONTEXT, "/esignAgreement"), data));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.esignDisclosure = esignDisclosure;